module.exports = __webpack_public_path__ + "static/img/noclick@2x.ef42c78b.png";